/*
 *
 * LeadsPage actions
 *
 */

import {
    DOWNLOAD_LEADS_REQUEST,
    FETCH_LEADS_REQUEST,
    FETCH_LEADS_SUCCESS,
    FETCH_LEADS_FAIL,
    DOWNLOAD_LEADS_SUCCESS,
    DOWNLOAD_LEADS_FAIL,
  } from './constants';
  
  export const downLoadLeadRequest = (params = null) => ({
    type: DOWNLOAD_LEADS_REQUEST,
    params
  });

  export const downLoadLeadSuccess = () => ({
    type: DOWNLOAD_LEADS_SUCCESS,
  });

  export const downLoadLeadFail = ({ errors }) => ({
    type: DOWNLOAD_LEADS_FAIL,
    errors
  });

  export const fetchLeadsRequest = (params = null) => ({
    type: FETCH_LEADS_REQUEST,
    params
  });

  export const fetchLeadSuccess = (payload) => ({
    type: FETCH_LEADS_SUCCESS,
    ...payload
  });

  // `statusCode` / `error_code` come off the rejected request (see
  // utils/request.js): rails answers a plan without lead capture with 403
  // `feature_not_available`, which the list renders as the upgrade prompt.
  export const fetchLeadFail = ({ errors, statusCode, error_code } = {}) => ({
    type: FETCH_LEADS_FAIL,
    errors,
    statusCode,
    errorCode: error_code,
  });
    